import React from 'react'
import { SetupForm } from './SetupForm'

export const CanvasSetup = () => {
  return (
    <div className="canvas-setup-main card-myed">
      <div className="canvas-flex-wrapper">
        <div className="canvas-form-container">
          <h3>1. Canvas Setup</h3>
          <p>Type your institution&apos;s Canvas URL in the field below.</p>
          <div className="example-wrapper">
            <div className="url-hint-text">
              It may look like the following:&nbsp;
            </div>
            <div className="url-example">
              https://&lt;your school&gt;.instructure.com/
            </div>
          </div>
          <SetupForm />
        </div>
        <div className="img-container">
          <img src="/static/instructor/media/canvas-logo-lms.png" />
        </div>
      </div>
    </div>
  )
}

